<script lang="ts">
	import {
		Accordion,
		AccordionTrigger,
		AccordionContent,
		AccordionItem
	} from "#lib/web-ui/ui/accordion/index.js";
	import type { FaqBaseProps } from "./faq.types";
	import FaqBase from "./faq-base.svelte";

	let { align = "center", ...props }: FaqBaseProps & { align?: "center" | "left" } = $props();
</script>

<FaqBase {...props}>
	{#snippet children({ title, subtitle, items, contactHref })}
		<div class={align === "center" ? "text-center" : "text-left"}>
			<h2 class="text-foreground text-3xl font-semibold text-balance lg:text-4xl">
				{title}
			</h2>
			{#if subtitle}
				<p class="text-muted-foreground mt-4 text-lg">{subtitle}</p>
			{/if}
		</div>

		<div class="mt-12">
			<Accordion type="single">
				{#each items as item, i}
					<AccordionItem value="item-{i}">
						<AccordionTrigger class="text-left text-base font-medium">
							{item.question}
						</AccordionTrigger>
						<AccordionContent class="text-muted-foreground">
							{item.answer}
						</AccordionContent>
					</AccordionItem>
				{/each}
			</Accordion>
			<p
				class={[
					"text-muted-foreground mt-8 text-sm",
					align === "center" ? "text-center" : "text-left"
				]}
			>
				Still have questions?{" "}
				<a href={contactHref} class="text-primary font-medium hover:underline">
					Get in touch
				</a>
			</p>
		</div>
	{/snippet}
</FaqBase>
